import { debounce } from 'lodash'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { SearchOutlined } from '@ant-design/icons'
import { Col, Input, Row, Select, Space, Tag } from 'antd'

// candidate components
import FilterDrawer from './candidate-filter-drawer'
import { CANDIDATE_STATUS } from './candidate-status-tab-list'

// store
import { setActiveJobId, setActiveTab } from '../store/candidate.slice'
import { changePage, getListJobs, jobState } from '../../jobs/store/job.slice'
import { unique } from '../../../helpers/uniqueArray'
import { searchCandidate } from '../../jobApplications/store/jobApplicant.slice'

const PanelHeader = () => {
    const [drawerVisible, setDrawerVisible] = useState(false)

    const dispatch = useDispatch()

    const closeDrawer = () => {
        setDrawerVisible(false)
    }
    const { activeTab, jobId } = useSelector((state) => state.candidateSlice)
    const { pageLimit, jobList, filter, isNext } = useSelector(jobState)

    const initialState = {
        filteredJobData: [],
    }

    // STATE
    const [state, setState] = useState(initialState)

    const debouncedSearch = debounce((value) => {
        dispatch(searchCandidate(value))
    }, 500)

    const initialJobCall = (search) => {
        setState((prevState) => ({
            ...prevState,
            filteredJobData: [],
        }))
        dispatch(
            changePage({
                currentPage: 1,
                skip: 0,
                pageLimit: state?.jobView === 'grid' ? pageLimit : 10,
            })
        )
        dispatch(
            getListJobs({
                limit: 10,
                skip: 0,
                search: search,
                jobId: jobId,
                status: activeTab,
            })
        )
    }

    // CHECK FOR LAZY LOADING IS_NEXT
    useEffect(() => {
        if (jobList?.length > 0) {
            let array = []
            jobList?.length > 0 &&
                jobList.forEach((data) => {
                    array = [...array, data]
                })
            let newArray = [...state?.filteredJobData, ...array]
            let finalArray = unique(newArray, '_id')
            setState((prevState) => ({
                ...prevState,
                filteredJobData: finalArray,
            }))
            if (!isNext) {
                return
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobList])

    // GET INITIAL TALENT LIST
    useEffect(() => {
        initialJobCall('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
            <Row justify={'space-between'} align={'middle'}>
                <Col span={10}>
                    <Input
                        placeholder="Search Candidate"
                        prefix={
                            <SearchOutlined
                                style={{
                                    fontSize: 16,
                                    marginRight: 5,
                                }}
                            />
                        }
                        style={{
                            height: '44px',
                        }}
                        onChange={(e) => debouncedSearch(e.target.value)}
                    />
                </Col>

                <Row align="middle" style={{ gap: '10px' }}>
                    <Col>
                        <Row align="middle">
                            <Row justify="end">
                                <Select
                                    value={activeTab || null}
                                    styles={{
                                        popup: {
                                            border: '1px solid transparent',
                                        },
                                    }}
                                    style={{ width: 220 }}
                                    placeholder="Select Status"
                                    onChange={(value) =>
                                        dispatch(setActiveTab(value))
                                    }
                                    allowClear
                                    options={CANDIDATE_STATUS.map((status) => ({
                                        label: (
                                            <Space>
                                                <Tag color={status.color}>
                                                    {status.label}
                                                </Tag>
                                            </Space>
                                        ),
                                        value: status.value,
                                    }))}
                                    rootClassName="select-search-job"
                                    showSearch
                                />
                            </Row>
                        </Row>
                    </Col>
                    <Col>
                        <Row align="middle">
                            <Row justify="end">
                                <Select
                                    value={jobId || null}
                                    style={{ width: 220 }}
                                    placeholder="Select Job"
                                    onChange={(value) => {
                                        dispatch(
                                            changePage({
                                                currentPage: 1,
                                                skip: 0,
                                                pageLimit: 10,
                                            })
                                        )
                                        dispatch(setActiveJobId(value))
                                        dispatch(
                                            getListJobs({
                                                limit: 10,
                                                skip: 0,
                                                filter: {
                                                    ...filter,
                                                    jobId: value,
                                                },
                                            })
                                        )
                                    }}
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                    options={state.filteredJobData.map(
                                        (job) => ({
                                            label: job.title,
                                            value: job._id,
                                        })
                                    )}
                                    rootClassName="select-search-job"
                                />
                            </Row>
                        </Row>
                    </Col>
                </Row>
            </Row>

            <FilterDrawer visible={drawerVisible} onClose={closeDrawer} />
        </div>
    )
}

export default PanelHeader
